export default "__VITE_ASSET__DF5ih3cl__"